const STORAGE_KEY = "sweetMedicalAuth";

export const getStoredAuth = () => {
    const storedAuth = localStorage.getItem(STORAGE_KEY);
    if (!storedAuth) {
        return null;
    }
    return JSON.parse(storedAuth);
};

export const getStoredUser = () => {
    const auth = getStoredAuth();
    return auth ? auth.user : null;
};

export const saveAuth = (user, token) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ user, token }));
};

export const removeAuth = () => {
    localStorage.removeItem(STORAGE_KEY);
};